module.exports = __webpack_public_path__ + "img/Unidad7-4.ac66ba57.png";